export enum RequiredReturnUrl {
  "FORGOT_PASSWORD" = "/notification/forgot-password",
  "PAYMENT_ADD_CARD" = "/payment/add-card",
  "PAYMENT_SMS" = "/payment/sms",
  "PAYMENT_PIN" = "/payment/pin",
  "PAYMENT_OTP" = "/payment/otp",
}
